import { render, staticRenderFns } from "./RevisionDocumentos.vue?vue&type=template&id=84d46b22"
import script from "./RevisionDocumentos.vue?vue&type=script&lang=js"
export * from "./RevisionDocumentos.vue?vue&type=script&lang=js"
import style0 from "./RevisionDocumentos.vue?vue&type=style&index=0&id=84d46b22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports